import { render, staticRenderFns } from "./ThgBatchUpdateSelectedStatusDialog.vue?vue&type=template&id=55f1be15&"
import script from "./ThgBatchUpdateSelectedStatusDialog.vue?vue&type=script&lang=ts&"
export * from "./ThgBatchUpdateSelectedStatusDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VForm})
